<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import AcikKapaliAnket from "@/components/widgets/AcikKapaliAnket";
import istatistik from "@/router/views/Anasayfa/istatistik.vue";
import {  MethodsActionsLoginSessionKey } from "@/state/helpers";
import store from "@/state/store"; 
import apigeneric from "@/helpers/apigeneric";
export default {
  mixins: [ apigeneric],
  page: {
    title: process.env.VUE_APP_NAME,
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    AcikKapaliAnket,
    istatistik,
  },
  data() {
    return {
      title: this.$t("StrAnasayfa.Title"),
      items: [
        {
          text: this.$t("StrAnasayfa.Title"),
          active: true,
        },
      ],
      fetchingStats: true,
      KullaniciYetkileri : store.getters.["auth/UserRolles"],
      AuthKontrol: store.getters.["auth/isAuth"],
      MenuRoleKontrol:false, 
    };
  }, 
  methods:{
    ...MethodsActionsLoginSessionKey,
    Get(){
      
    this.MuneRolesControl();
    },
    MuneRolesControl() {  
      let YetkiSorgu = this.UserRolles.filter((item) =>
       item.includes("SuperAdmin") || item.includes("AnketAdmin")
      );
      if (YetkiSorgu.length != 0) this.MenuRoleKontrol = true; 
    },
  },
  created(){   
    if(!this.AuthKontrol){ 
        if(this.$route.params.Sessionkey && this.$route.params.Email){
        let Data={
          Email: this.$route.params.Email,
          Sessionkey: this.$route.params.Sessionkey
        }   
         this.ActionsLoginSessionKey(Data).then((res) => {   
          if (res == true) { 
           window.location.href = "/";
          }  else{
            window.location=this.$config.LOGIN_URL
          }
        });
      } 
  }

}
};
</script>

<template>
  <Layout> 
    <PageHeader :title="title" :items="items" /> 
    <div class="row"  v-if="AuthKontrol && KullaniciYetkileri && MenuRoleKontrol">
      <AcikKapaliAnket />
    </div>
    <div class="card" v-if="AuthKontrol && KullaniciYetkileri && MenuRoleKontrol">
      <istatistik />
    </div>
    <div class="row" v-if="!KullaniciYetkileri">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center p-5">
              <h3>Yetkiniz bulunmamaktadır lütfen yetki talep edin.</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
